import logoUrl from '@/assets/logo.svg'
import { cn } from '../lib/cn.ts'

export function Logo({ height = 20, className }: { height?: number; className?: string }) {
  return (
    <img
      src={logoUrl}
      alt="Manaro"
      style={{ height }}
      className={cn('w-auto select-none', className)}
      draggable={false}
    />
  )
}
